import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle, isLanding }) => (
  <header
    style={{
      background: `#001c31`,
      marginBottom: `1.45rem`,
      opacity: isLanding ? 0 : 1,
      transition: `0.25s opacity ease-in-out`,
      position: `absolute`,
      left: 0,
      top: 0,
      width: `100%`,

      height: 60,
    }}
  >
    <div
      style={{
        margin: `0 auto`,

        padding: `19px 50px`,
      }}
    >
      <h1 style={{ margin: 0, fontSize: 22 }}>
        <Link
          to="/"
          style={{
            color: `#ffe8c0`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
